@if (this.showDialog) {
  <dx-popup
    [maxWidth]="450"
    [height]="auto"
    [showCloseButton]="true"
    [showTitle]="true"
    title="{{ 'EDIT_IMAGE' | translate }}"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="this.showDialog"
    class="popup-height-auto"
    animation="{ show:'duration:400'}">
    <div *dxTemplate="let data of 'content'">
      <edit-image (onFileAdded)="this.onFileAdded($event)"></edit-image>
      <div class="text-center">
        <dx-button class="btn me-2" icon="mdi mdi-content-save" text="{{ 'SAVE' | translate }}" (onClick)="this.onSave()"></dx-button>
        <dx-button class="btn btn-light ms-2" text="{{ 'CLOSE' | translate }}" (onClick)="this.onCancel()"></dx-button>
      </div>
    </div>
  </dx-popup>
}
